import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  revert?: boolean
}

export const Label = styled.label`
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  background: #ccc;
  border: solid 3px #df7a58;

  margin: ${(props: IStyleProps) => {
    if (props.revert) return '0px 0px 0px 8px'
    return '0px 8px 0px 0px'
  }};

  @media only screen and (min-width: 1441px) {
    width: 43px;
    height: 43px;
  }

  .edit-user-icon {
    display: flex;
    justify-content: center;
    position: absolute;

    img {
      width: 16px;
      height: 16px;

      @media only screen and (min-width: 1441px) {
        width: 18px;
        height: 18px;
      }
    }

    input {
      display: none;
    }

    &:hover {
      opacity: 0.9;
    }
  }

  .user-icon {
    position: absolute;
    width: 38px;
    height: 38px;
    border-radius: 10px;

    @media only screen and (min-width: 1441px) {
      width: 43px;
      height: 43px;
    }
    &:hover {
      opacity: 0.1;
    }
  }
`

export const Div = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  .greeting {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    margin-bottom: 6px;
    margin-top: 1px;

    color: #1c1d22;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    text-align: ${(props: IStyleProps) => {
      if (props.revert) return 'end'
      return 'start'
    }};

    @media only screen and (min-width: 1441px) {
      font-size: 13px;
    }
  }

  .greeting-container {
    display: flex;
    flex-direction: column;
  }

  .user-name {
    color: #1c1d22;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    @media only screen and (min-width: 1441px) {
      font-size: 15px;
    }
  }
`
